/* eslint-disable react/jsx-no-duplicate-props */
import React from 'react';

// eslint-disable-next-line arrow-body-style
function Neutral() {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" className="h-28 w-28" fill="none" viewBox="-1 -1 18 18" strokeWidth="1" stroke="currentColor">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path d="M4 10.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5zm3-4C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5S9.448 8 10 8s1-.672 1-1.5z" />
      </svg>
    </div>
  );
}

export default Neutral;
